/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import * as S from "../../styles";

export interface ISelectInputProps {
    id: string;
    label?: string;
    labelColor?: string;
    errorText?: string;
    readOnly?: boolean;
    disabled?: boolean;
    options?: { id: string; label: string }[];
    value?: string;
    required?: boolean;
    placeholder?: string;
    onCompChange?(id: string, payload: any): void;
    hasError?: boolean;
}

export const SelectInput = ({
    id,
    label,
    labelColor,
    options,
    errorText,
    value,
    required,
    placeholder,
    onCompChange,
    hasError,
    readOnly,
    disabled
}: ISelectInputProps) => {
    const [textValue, setTextValue] = useState(value ?? "");
    const [isInvalid, setInvalid] = useState(false);
    useEffect(() => {
        if (hasError) {
            setInvalid(true);
        }
    }, [hasError]);
    useEffect(() => {
        if (value)
            setTextValue(value)
    }, [value])
    const onChange = (id: string, e: any) => {
        setTextValue(e?.target?.value);
        console.log(id, e?.target?.value);
        onCompChange && onCompChange(id, e?.target?.value);
    };

    const _renderLabelIf = () => {
        if (label) {
            return (
                <S.FormLabel color={labelColor}>
                    {label}
                    {required && <sup style={{ color: "red" }}>*</sup>}
                </S.FormLabel>
            );
        }
        return null;
    };

    const _renderErrorTextIf = () => {
        if (hasError && errorText) {
            return (
                <S.FeedbackOtherLabel type="tooltip">
                    {errorText}
                </S.FeedbackOtherLabel>
            );
        }
        return null;
    };

    return (
        <>
            <Form.Group id={id} className="mb-4 formgroup">
                {_renderLabelIf()}
                <InputGroup>
                    <Form.Control
                        className="formcontrol shadow-none"
                        value={textValue}
                        onChange={onChange.bind(null, id)}
                        required={required}
                        as="select"
                        placeholder={placeholder}
                        readOnly={readOnly}
                        disabled={disabled}
                        isInvalid={isInvalid}
                    >
                        <option>Select Options</option>
                        {options?.map(
                            (option: { id: string; label: string }) => (
                                <option
                                    key={`tweety-option-${option.id}`}
                                    value={option.id}
                                >
                                    {option.label}
                                </option>
                            )
                        )}
                    </Form.Control>
                </InputGroup>
                {_renderErrorTextIf()}
            </Form.Group>
        </>
    );
};

SelectInput.defaultProps = {
    required: false,
    hasError: false,
    readOnly: false
};
